// @ts-nocheck
import { encodeJson as encodeJson_1, decodeJson as decodeJson_1, encodeBinary as encodeBinary_1, decodeBinary as decodeBinary_1, } from "../../TimeRange";
import { encodeJson as encodeJson_2, decodeJson as decodeJson_2, encodeBinary as encodeBinary_2, decodeBinary as decodeBinary_2, } from "../../google/protobuf/Empty";
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../runtime/json/scalar";
import { WireType, } from "../../../runtime/wire/index";
import { default as serialize, } from "../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        couponId: "0",
        issueCondition: undefined,
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    var _a;
    const result = {};
    if (value.couponId !== undefined)
        result.couponId = tsValueToJsonValueFns.int64(value.couponId);
    switch ((_a = value.issueCondition) === null || _a === void 0 ? void 0 : _a.field) {
        case "signUpRange": {
            result.signUpRange = encodeJson_1(value.issueCondition.value);
            break;
        }
        case "targetUsers": {
            result.targetUsers = encodeJson_2(value.issueCondition.value);
            break;
        }
    }
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.couponId !== undefined)
        result.couponId = jsonValueToTsValueFns.int64(value.couponId);
    if (value.signUpRange !== undefined)
        result.issueCondition = { field: "signUpRange", value: decodeJson_1(value.signUpRange) };
    if (value.targetUsers !== undefined)
        result.issueCondition = { field: "targetUsers", value: decodeJson_2(value.targetUsers) };
    return result;
}
export function encodeBinary(value) {
    var _a;
    const result = [];
    if (value.couponId !== undefined) {
        const tsValue = value.couponId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    switch ((_a = value.issueCondition) === null || _a === void 0 ? void 0 : _a.field) {
        case "signUpRange": {
            const tsValue = value.issueCondition.value;
            result.push([2, { type: WireType.LengthDelimited, value: encodeBinary_1(tsValue) }]);
            break;
        }
        case "targetUsers": {
            const tsValue = value.issueCondition.value;
            result.push([3, { type: WireType.LengthDelimited, value: encodeBinary_2(tsValue) }]);
            break;
        }
    }
    return serialize(result);
}
const oneofFieldNumbersMap = {
    issueCondition: new Set([2, 3]),
};
const oneofFieldNamesMap = {
    issueCondition: new Map([
        [2, "signUpRange"],
        [3, "targetUsers"],
    ]),
};
export function decodeBinary(binary) {
    var _a;
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    const wireFieldNumbers = Array.from(wireFields.keys()).reverse();
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.couponId = value;
    }
    oneof: {
        const oneofFieldNumbers = oneofFieldNumbersMap.issueCondition;
        const oneofFieldNames = oneofFieldNamesMap.issueCondition;
        const fieldNumber = wireFieldNumbers.find(v => oneofFieldNumbers.has(v));
        if (fieldNumber == null)
            break oneof;
        const wireValue = wireFields.get(fieldNumber);
        const wireValueToTsValueMap = {
            [2](wireValue) { return wireValue.type === WireType.LengthDelimited ? decodeBinary_1(wireValue.value) : undefined; },
            [3](wireValue) { return wireValue.type === WireType.LengthDelimited ? decodeBinary_2(wireValue.value) : undefined; },
        };
        const value = (_a = wireValueToTsValueMap[fieldNumber]) === null || _a === void 0 ? void 0 : _a.call(wireValueToTsValueMap, wireValue);
        if (value === undefined)
            break oneof;
        result.issueCondition = { field: oneofFieldNames.get(fieldNumber), value: value };
    }
    return result;
}
